import { ReactNode, createContext, useContext } from "react";
import { useFilterBilling } from "./filter-billing.hook";

const FilterBillingContext = createContext(
  {} as ReturnType<typeof useFilterBilling>
);
export function useFilterBillingContext() {
  return useContext(FilterBillingContext);
}

interface FilterBillingProviderProps {
  children: ReactNode;
}
export function FilterBillingProvider({
  children,
}: FilterBillingProviderProps) {
  return (
    <FilterBillingContext.Provider value={useFilterBilling()}>
      {children}
    </FilterBillingContext.Provider>
  );
}